import { QuestionGroupConfigurationPanel } from "@/components/non_registrant/question-group-configuration-panel";
import { SETUP_PAGE_SHELL_CLASS } from "@/components/portal/setup-page-layout";
import LoadingScreen from "@/components/ui/loading-screen";
import { useAuthQuerySetup } from "@/hooks/use-auth-query-setup";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/question-group-configuration")({
  component: QuestionGroupConfigurationPage,
});

function QuestionGroupConfigurationPage() {
  const { isAuthSetupComplete } = useAuthQuerySetup();

  if (!isAuthSetupComplete) {
    return <LoadingScreen />;
  }

  return (
    <div className={SETUP_PAGE_SHELL_CLASS}>
      <QuestionGroupConfigurationPanel />
    </div>
  );
}
